<template>
  <Layout @componentKey="gotRefresh" @currentPage="currentPage" :hasPagination="true" :hasBreadcrumbs="true" :amount="amount.aantal" :amountToShow="amountToShow" :openModalHandler="openModalHandler">
    <div class="content">
      <div class="page-content" ref="tableContent">
        <MainTitle :title="this.$router.currentRoute.name"  />
        <FlowsTable @selectedAmount="gotAmountToShow" @selectedRow="gotFlow" :flows="this.flows" :totalItems="amount.aantal" @sorting="gotSorting" @refresh="gotRefresh" />
      </div>
      <div class="sidebar">
        <TableAction :hasButton="this.userDetails.isAdmin == 1 ? true : false" @clickedButton="gotClick" title="Add Production Flow" :isAdd="true"/>
        <TableDetail height="44" v-if="this.selectedFlow" :details="this.selectedFlow"  @refresh="gotRefreshPageData"/>
      </div>
    </div>
  </Layout>
</template>
<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import Loading from "@/components/base/Loading";
import FlowsTable from "@/components/TblFlows";
import TableAction from "@/components/TableAction";
import TableDetail from "@/components/TblFlowDetail";
import MainTitle from "@/components/base/MainTitle";
import TableFilter from "@/components/base/TableFilter";

export default {
  name: "management-flows",
  props: {
    compKey: Number
  },
  computed: {
    maxRows: function () {
      let heightContent = this.$refs.tableContent.clientHeight;
      let heightSingleRow = 76

      return Math.ceil(heightContent / heightSingleRow) - 2
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  data () {
    return {
      isLoading: false,
      flows: [],
      amount: 0,
      selectedFlow: null,
      pagina: 1,
      openModalHandler: false,
      sortingOn: "ref",
      isAscending: true,
      amountToShow: 8
    }
  },
  components: {
    Layout,
    Loading,
    TableFilter,
    FlowsTable, 
    MainTitle, 
    TableAction,
    TableDetail,
  },
  mounted() {
    this.amountToShow = this.maxRows
    this.getData()
  },
  methods: {
    gotAmountToShow(val) {
      if(val == 9) {
        this.amountToShow = this.maxRows
      } else {
        this.amountToShow = parseInt(val)
      }
      this.pagina = Math.ceil(this.amount.aantal / parseInt(val))
      this.getData()
    },
    getData() {
      var that = this
      this.isLoading = true
      let offset = this.pagina != 1 ? (this.pagina * this.amountToShow) - this.amountToShow : 0
      let asc = this.isAscending ? "A" : "D"
      this.$http.get(this.$endpoint + 'management/productionFlow/all/' + this.sortingOn + '/' + asc + '/' + this.amountToShow + '/' + offset)
      .then(response => {
        that.amount = response.data.pop()
        that.flows = response.data
        that.selectedFlow = null

        switch(this.sortingOn) {
          case 'ref':
            if(this.isAscending) {
              that.flows.sort((a, b) => (a.ref > b.ref) ? 1 : -1)
            } else {
              that.flows.sort((a, b) => (a.ref < b.ref) ? 1 : -1)
            }
            break;
        }
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch(err => console.log(err));
        } else {
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: ${ error }`,
            'error'
          );
        }
      })
    },
    currentPage(page) {
      this.pagina = page // someValue
    },
    gotSorting(sort) {
      this.isAscending = sort.asc
      this.sortingOn = sort.on
      this.getData()
    },
    gotFlow(flow) {
      this.selectedFlow = flow // someValue
    },
    gotClick(val) {
      this.openModalHandler = !this.openModalHandler;
    },
    gotRefresh(val) {
      this.pagina = 1
      this.amount = 0
      this.getData()
    },
    gotRefreshPageData(val) {
      this.getData()
    }
  },
  watch: {
    pagina: function (val) {
      this.getData()
    },   
    amount: function (newVal, oldVal) {
      if(newVal.aantal != oldVal && newVal.aantal != oldVal.aantal && oldVal != 0) {
        this.getData()
      }
    }, 
    filter: function (val) {
      this.getData()
    } 
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */
</style>;